import React from "react";
import { useLocation, Link } from "react-router-dom";
import { Icon, Thumbnail, Tooltip } from "@culturehq/components";
import * as CHQ from "chq";

import { useProfile } from "app/context";
import { t } from "app/utils";

import PostModal from "components/PostModal";
import getUserName from "app/utils/getUserName";
import SharePhotoAction from "./suggested-actions/SharePhotoAction";

const ProfileThumbnail: React.FC = () => {
  const { profile } = useProfile();

  return (
    <div className="FeedItem__user">
      <Link to="/profile">
        <Thumbnail
          className="Thumbnail"
          image={profile.avatar.mediumUrl}
          title={getUserName(profile)}
        />
      </Link>
    </div>
  );
};

const CreateEventAction: React.FC = () => (
  <Link to="/events/new/type" className="Button Button-inverted Button-primary" aria-label={t("Create an event")}>
    <Icon icon="calendar-star" />
  </Link>
);

const SuggestedActions: React.FC = () => {
  const location = useLocation();
  const { profile: rawProfile } = useProfile();

  // This shouldn't be necessary but it is because currently useProfile is lying
  // about its state. In reality it's not a union, it's just a Profile, because
  // if we've gotten this far we're definitely logged in.
  const profile = rawProfile as CHQ.Profile;
  const {
    eventsEnabled,
    postsEnabled,
    userCreatedEventsEnabled,
    userCreatedPostsEnabled
  } = profile.organization;

  if (!postsEnabled || (!profile.organizationAdmin && !userCreatedPostsEnabled)) {
    return null;
  }

  return (
    <div className="FeedItem FeedItem__SuggestedActions">
      <div className="FeedItem__preview">
        <div className="main-container">
          <ProfileThumbnail />
          {(profile.organizationAdmin || userCreatedPostsEnabled) && (
            <PostModal initialOpen={location.hash === "#post"} />
          )}
        </div>
        <div className="buttons-container">
          <div className="FeedItem__SuggestedActions__preview">
            {(profile.organizationAdmin || userCreatedEventsEnabled)
              && eventsEnabled && (
              <Tooltip tip={t("Create an event")}>
                <CreateEventAction />
              </Tooltip>
            )}
            {(profile.organizationAdmin || userCreatedPostsEnabled) && (
              <Tooltip tip={t("Share a photo")}><SharePhotoAction />{" "}</Tooltip>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuggestedActions;
